import SectionWave from '../components/SectionWave';
import SEO from '../components/SEO';
import './PageShared.css';
import './Faciliteter.css';

import imgSmaBorn from '../assets/IMG_4296-scaled.jpg';
import imgStoreBorn from '../assets/IMG_5002-700x700.jpg';
import imgHoppe from '../assets/IMG_2051-1536x2048.jpg';
import imgFaelles1 from '../assets/IMG_6092-700x700.jpg';
import imgFaelles2 from '../assets/Ny/cafeborde.jpg';
import imgAmme from '../assets/7474A29F-E5E0-4ECC-801F-8ABC532D8136-2-1024x772.jpg';
import imgPusle from '../assets/puslerum.jpg';
import imgExtra1 from '../assets/Ny/att.J6o5JYhC25O74_HiofMr1yYlRuq_PDX9J0COnOu0fso.jpeg';
import imgExtra2 from '../assets/Ny/att.LLqaIdFZ_AT9rRAQfk34D_J5ZPWAbsGRwz4Jp-4tKvA.jpeg';

const praktisk = [
  { icon: '🚗', title: 'Gratis parkering', desc: 'Direkte foran hoveddøren' },
  { icon: '🚌', title: 'Bus nr. 230', desc: 'Stopper næsten lige udenfor' },
  { icon: '🍼', title: 'Barnevognsparkering', desc: 'Plads til barnevogne udenfor' },
  { icon: '♿', title: 'Tilgængelighed', desc: 'Handicapvenlig indgang' },
];

export default function Faciliteter() {
  return (
    <main className="page">
      <SEO
        title="Faciliteter"
        path="/faciliteter"
        description="Udforsk Little-Stars' faciliteter i Randers NV: 2 legeområder (0–3 år og 4+ år), hoppeborg, klatrevæg, ammerum, puslerum, minicafé og gratis parkering."
      />

      {/* PAGE HERO */}
      <div className="page-hero">
        <div className="page-hero-bg" style={{ '--c1': '#F4A7C0', '--c2': '#7DCFCA' }} />
        <div className="page-hero-content">
          <div className="page-label">Faciliteter</div>
          <h1>Alt hvad I behøver - <span className="gradient-text">under ét tag</span></h1>
          <p>To legeområder, fællesområde, ammerum, puslerum og meget mere.</p>
        </div>
      </div>

      <SectionWave color="#f7f8fc" />

      {/* LEGEOMRÅDE - DE SMÅ */}
      <section className="fac-section bg-soft">
        <div className="container">
          <div className="fac-layout">
            <div className="fac-imgs">
              <img src={imgExtra1} alt="Legeområde for de mindste" className="fac-img-main" />
              <img src={imgSmaBorn} alt="Legerum detalje" className="fac-img-side" />
            </div>
            <div className="fac-text">
              <div className="section-label">Legeområder</div>
              <h2 className="section-title">Noget for <span className="gradient-text">alle aldre</span></h2>
              <p>
                Vi har 2 legeområder, et for de små og et for de lidt større. Der er plads til alle
                begge steder, og kun fantasien sætter grænser for de mange timers leg.
              </p>
              <div className="fac-area-card fac-pink">
                <div className="fac-area-header">
                  <span className="fac-age-badge">0–3 år</span>
                  <h3>De mindste</h3>
                </div>
                <p>
                  I vores legeområde for de små finder I fire hjemmebyggede huse med en masse legetøj,
                  herunder legekøkken, bager, alt til dukkelegen og meget andet. Her finder I også et
                  boldbassin, rutsjebane, sansegynge og almindelig gynge, samt to kravlegårdstelte.
                </p>
                <p className="fac-note">
                  🚗 Vores højtelskede Paddington bil finder I også her - til fri afbenyttelse. Start den
                  bare ved at trykke på startknappen, men pas godt på ham, han er en gammel sag.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* LEGEOMRÅDE - DE STORE */}
      <section className="fac-section bg-white">
        <div className="container">
          <div className="fac-layout fac-layout-reverse">
            <div className="fac-text">
              <div className="fac-area-card fac-teal" style={{ marginTop: 0 }}>
                <div className="fac-area-header">
                  <span className="fac-age-badge fac-age-teal">4+ år</span>
                  <h3>De større</h3>
                </div>
                <p>
                  I det store legeområde er der plads til at de større børn kan få fri leg og boltre sig.
                  Her finder I blandt andet hoppeborge, bordfodbold, airhockey, minipool, klatrevæg og
                  parkourbane - men også et hyggeligt sofaområde og to fine kravlegårdstelte til de små børn.
                </p>
                <p className="fac-note">
                  Dette gør det nemt for mor og far at holde øje med de store børn, men stadig kunne
                  aktivere de små.
                </p>
              </div>
              <p className="fac-disclaimer">
                Alt ophold i vores legeområder og Little-Stars lokaler er på eget ansvar.
              </p>
            </div>
            <div className="fac-imgs">
              <img src={imgStoreBorn} alt="Klatrestruktur" className="fac-img-main" />
              <img src={imgHoppe} alt="Hoppeborg" className="fac-img-side" />
            </div>
          </div>
        </div>
      </section>

      <SectionWave color="#f7f8fc" />

      {/* PUSLE + AMME */}
      <section className="fac-section bg-soft">
        <div className="container">
          <div className="fac-cards-row">

            <div className="fac-info-card">
              <img src={imgPusle} alt="Puslerum" className="fac-info-img" />
              <div className="fac-info-body">
                <span className="fac-info-icon">👶</span>
                <h3>Puslerum</h3>
                <p>
                  Little-Stars tilbyder et roligt og lukket pusleområde. Vi har etableret et lyst og
                  roligt puslerum, hvor du i ro og mag kan pusle dit barn.
                </p>
              </div>
            </div>

            <div className="fac-info-card">
              <img src={imgAmme} alt="Ammerum" className="fac-info-img" />
              <div className="fac-info-body">
                <span className="fac-info-icon">🤱</span>
                <h3>Ammeplads</h3>
                <p>
                  Hos Little-Stars finder du en masse rolige ammepladser med sofaer og lænestole, hvor du kan sidde
                  og amme dit barn i rolige omgivelser.
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>

      <SectionWave color="#ffffff" />

      {/* FÆLLESOMRÅDE */}
      <section className="fac-section bg-white">
        <div className="container">
          <div className="fac-layout">
            <div className="fac-imgs fac-imgs-tall">
              <img src={imgFaelles1} alt="Fællesområde" className="fac-img-main" />
              <img src={imgFaelles2} alt="Caféborde" className="fac-img-side" style={{ objectPosition: 'center 55%' }} />
            </div>
            <div className="fac-text">
              <div className="section-label">Fællesområde</div>
              <h2 className="section-title">Mad, kaffe og <span className="gradient-text">god stemning</span></h2>
              <p>
                I vores fællesområde kan du nyde mad og drikke ved en af vores mange borde. I er
                velkomne til at medbringe mad hjemmefra, men drikkevarer skal købes i huset. Vi har
                altid gratis vand til rådighed.
              </p>
              <p style={{ marginTop: '0.75rem' }}>
                Her er plads til en masse snak, mens børnene hygger sig i et af vores legeområder.
                Fællesområdet er i forlængelse af legeområdet for de små, så der er udsyn til børnene.
              </p>
              <div className="fac-rule-card">
                ☕ Alt mad og drikke skal nydes i fællesområdet - med undtagelse af kaffen, som du
                er velkommen til at tage med ind i sofaerne eller ammerummet.
              </div>
            </div>
          </div>
        </div>
      </section>

      <SectionWave color="#f7f8fc" />

      {/* PRAKTISK */}
      <section className="fac-section bg-soft">
        <div className="container">
          <div className="section-label">Praktisk info</div>
          <h2 className="section-title">Nem adgang for <span className="gradient-text">alle</span></h2>
          <div className="praktisk-grid">
            {praktisk.map(p => (
              <div className="praktisk-card" key={p.title}>
                <div className="praktisk-icon">{p.icon}</div>
                <strong>{p.title}</strong>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <SectionWave color="#ffffff" />

      {/* AFD BANNER */}
      <section className="fac-section bg-white">
        <div className="container">
          <div className="fac-afd-banner">
            <div className="fac-afd-imgs">
              <img src={imgExtra2} alt="Little-Stars lokale" />
            </div>
            <div className="fac-afd-text">
              <div className="section-label">To afdelinger</div>
              <h2 className="section-title">Afdeling 1 <span className="gradient-text">&amp;</span> Afdeling 2</h2>
              <p>
                Vi har to afdelinger. Afdeling 1 kan lejes til private arrangementer i weekenden,
                men afdeling 2 er altid åben for medlemmer og dagsbesøgende - også ved udlejninger.
              </p>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}
